// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./default_logo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

body, html {

    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;

    font-size: 12px;

    height: 100%;
    padding: 0;
    margin: 0;
}

body {
    position: relative;
}

body::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 90%;
    opacity: 0.02;
    z-index: -1;
    pointer-events: none;
}

a:link {
    /*text-decoration: none;*/
}

.content,
.content > div {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.content > .message {
    text-align: center;
    display: table;

    font-size: 16px;
    color: #111;
}

.content > .message .note {
    vertical-align: middle;
    text-align: center;
    display: table-cell;
}

.content > .error .details {
    max-width: 500px;
    font-size: 12px;
    margin: 20px auto;
    text-align: left;
}

.content > .error pre {
    border: solid 1px #CCC;
    background: #EEE;
    padding: 10px;
}

.content:not(.with-error) > .error,
.content.with-error > .intro,
.content.with-diagram > .intro {
    display: none;
}


.content .canvas,
.content.with-error .canvas {
    visibility: hidden;
}

.content.with-diagram .canvas {
    visibility: visible;
}

.buttons {
    position: fixed;
    bottom: 20px;
    left: 20px;

    padding: 0;
    margin: 0;
    list-style: none;
}

.buttons > li {
    display: inline-block;
    margin-right: 10px;
}
.buttons > li > a {
    background: #DDD;
    border: solid 1px #666;
    display: inline-block;
    padding: 5px;
}

.buttons a {
    opacity: 0.3;
}

.buttons a.active {
    opacity: 1.0;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,2DAA2D;;IAE3D,eAAe;;IAEf,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAA2C;IAC3C,4BAA4B;IAC5B,2BAA2B;IAC3B,oBAAoB;IACpB,aAAa;IACb,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;;IAEd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;;;IAGI,aAAa;AACjB;;;AAGA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;;IAEV,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\nbody, html {\n\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n    font-size: 12px;\n\n    height: 100%;\n    padding: 0;\n    margin: 0;\n}\n\nbody {\n    position: relative;\n}\n\nbody::before {\n    content: \"\";\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url(\"./default_logo.svg\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 90%;\n    opacity: 0.02;\n    z-index: -1;\n    pointer-events: none;\n}\n\na:link {\n    /*text-decoration: none;*/\n}\n\n.content,\n.content > div {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\n.content > .message {\n    text-align: center;\n    display: table;\n\n    font-size: 16px;\n    color: #111;\n}\n\n.content > .message .note {\n    vertical-align: middle;\n    text-align: center;\n    display: table-cell;\n}\n\n.content > .error .details {\n    max-width: 500px;\n    font-size: 12px;\n    margin: 20px auto;\n    text-align: left;\n}\n\n.content > .error pre {\n    border: solid 1px #CCC;\n    background: #EEE;\n    padding: 10px;\n}\n\n.content:not(.with-error) > .error,\n.content.with-error > .intro,\n.content.with-diagram > .intro {\n    display: none;\n}\n\n\n.content .canvas,\n.content.with-error .canvas {\n    visibility: hidden;\n}\n\n.content.with-diagram .canvas {\n    visibility: visible;\n}\n\n.buttons {\n    position: fixed;\n    bottom: 20px;\n    left: 20px;\n\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n.buttons > li {\n    display: inline-block;\n    margin-right: 10px;\n}\n.buttons > li > a {\n    background: #DDD;\n    border: solid 1px #666;\n    display: inline-block;\n    padding: 5px;\n}\n\n.buttons a {\n    opacity: 0.3;\n}\n\n.buttons a.active {\n    opacity: 1.0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
